import Rails from '@rails/ujs'
import { Turbo } from '@hotwired/turbo-rails'
import 'flowbite/dist/flowbite.turbo'

import LocalTime from 'local-time'
import '~/channels/index.js'
import '~/controllers/index.js'

import '~/stylesheets/application.scss'

window.Rails = Rails
window.Turbo = Turbo

LocalTime.start()
